import { StyleSheet } from 'react-native-unistyles';

export const leagueRouteStyles = StyleSheet.create((theme) => ({
  content: {
    padding: theme.spacing.m,
    paddingBottom: 100,
  },
  flex: {
    flex: 1,
  },
}));
